import React from 'react';
function PredefinedIcon() {
  return (
    <svg width='28' height='28' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='8' fill='#8CCC43' />
      <path
        d='M12.9999 6.39999V25.6M17.1999 9.99999H20.7999M17.1999 13.6H20.7999M17.1999 17.2H17.7999M9.9999 25.6H21.9999C23.9881 25.6 25.5999 23.9882 25.5999 22V9.99999C25.5999 8.01177 23.9881 6.39999 21.9999 6.39999H9.9999C8.01168 6.39999 6.3999 8.01177 6.3999 9.99999V22C6.3999 23.9882 8.01168 25.6 9.9999 25.6Z'
        stroke='white'
        stroke-width='2'
        stroke-linecap='round'
      />
    </svg>
  );
}

export default PredefinedIcon;
